<template>
  <div class="player-video">
    <div class="video">
      <youtube
        v-if="youtubeId"
        ref="youtube"
        :player-vars="playerVars"
        :video-id="youtubeId"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerVideo',

  props: {
    youtubeId: { type: String, default: null },
  },

  data() {
    return {
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    };
  },
};
</script>

<style lang="stylus" scoped>
.player-video {
  margin-left: 50px;
  margin-right: 80px;
  max-width: 800px;

  +mobile() {
    margin-left: 20px;
    margin-right: 20px;
  }

  .video {
    width: 100%;
    box-sizing: border-box;
    margin: 0;

    +desktop() { width: 90%; }
  }
}
</style>

<style lang="stylus">
iframe {
  aspect-ratio: 16/9;
  width: 100%;
  height: auto;
}
</style>
